import React from 'react';
import { Skeleton } from './skeleton';
import { cn } from '@/lib/utils';

/**
 * ListSkeleton — placeholders reutilizáveis para estados de loading.
 * Variantes disponíveis: 'row' | 'card' | 'notification' | 'metric' | 'kanban-card'
 * Ajusta a forma para se parecer com o conteúdo real e reduzir a percepção de espera.
 */
export function ListSkeleton({ items = 5, variant = 'row', className }) {
  const arr = Array.from({ length: items });

  if (variant === 'metric') {
    return (
      <div className={cn('grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4', className)}>
        {arr.map((_, i) => (
          <div key={i} className="rounded-xl border border-stone-200 bg-white p-5 space-y-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-3 w-20" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className={cn('grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4', className)}>
        {arr.map((_, i) => (
          <div key={i} className="rounded-xl border border-stone-200 bg-white p-5 space-y-3">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-5 w-14 rounded-full" />
            </div>
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
            <div className="flex gap-2 pt-2">
              <Skeleton className="h-8 w-20 rounded-full" />
              <Skeleton className="h-8 w-24 rounded-full" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'kanban-card') {
    return (
      <div className={cn('space-y-3', className)}>
        {arr.map((_, i) => (
          <div key={i} className="rounded-lg border border-stone-200 bg-white p-3 space-y-2">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="h-2 w-full rounded-full" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'notification') {
    return (
      <div className={cn('divide-y', className)}>
        {arr.map((_, i) => (
          <div key={i} className="p-4 flex gap-3 items-start">
            <Skeleton className="h-8 w-8 rounded-full flex-shrink-0" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-1/3" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  // 'row' — default
  return (
    <div className={cn('space-y-2', className)}>
      {arr.map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-lg border border-stone-200 bg-white p-3">
          <Skeleton className="h-10 w-10 rounded-full flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-3 w-2/3" />
          </div>
          <Skeleton className="h-6 w-16 rounded-full" />
        </div>
      ))}
    </div>
  );
}

export default ListSkeleton;
